const info = theme => ({
  backgroundColor: theme.tokens.ComponentBadgeVariantInfoBg
});
const error = theme => ({
  backgroundColor: theme.tokens.ComponentBadgeVariantErrorBg
});
const success = theme => ({
  backgroundColor: theme.tokens.ComponentBadgeVariantSuccessBg
});
const caution = theme => ({
  backgroundColor: theme.tokens.ComponentBadgeVariantCautionBg
});
const white = theme => ({
  backgroundColor: theme.tokens.ComponentBadgeVariantWhiteBg
});
const light = theme => ({
  backgroundColor: theme.tokens.ComponentBadgeVariantLightBg
});
const dark = theme => ({
  backgroundColor: theme.tokens.ComponentBadgeVariantDarkBg,
  color: theme.tokens.ComponentBadgeVariantDarkColor
});
const transparent = theme => ({
  backgroundColor: theme.tokens.ComponentBadgeVariantTransparentBg,
  border: `1px solid ${theme.tokens.ComponentBadgeVariantTransparentBorderColor}`
});
const transparentDark = theme => ({
  border: `1px solid ${theme.tokens.ComponentBadgeVariantTransparentDarkBorderColor}`,
  color: theme.tokens.ComponentBadgeVariantTransparentDarkColor,
  backgroundColor: 'transparent'
});
const getColorStyle = (badgeVariant, theme) => {
  switch (badgeVariant) {
    case 'info':
      {
        return info(theme);
      }
    case 'error':
      {
        return error(theme);
      }
    case 'success':
      {
        return success(theme);
      }
    case 'caution':
      {
        return caution(theme);
      }
    case 'white':
      {
        return white(theme);
      }
    case 'light':
      {
        return light(theme);
      }
    case 'dark':
      {
        return dark(theme);
      }
    case 'transparent':
      {
        return transparent(theme);
      }
    case 'transparent-dark':
      {
        return transparentDark(theme);
      }
    default:
      {
        return light(theme);
      }
  }
};
const badgeStyleDecorator = (badgeVariant, style, theme) => {
  return {
    ...style,
    ...getColorStyle(badgeVariant, theme)
  };
};
export default badgeStyleDecorator;